// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3QSf7","imageUploader":"EGiftCard_imageUploader__f7vJ1"};